module.exports = __webpack_public_path__ + "img/multi.49b97a33.png";